module.exports = __webpack_public_path__ + "static/media/connect-logo.81aaed1c.svg";